import { RewardPool } from '@shared/api/types/rewardPools';
import { useAuth } from '@shared/common/providers/AuthProvider';
import { useIsSelfJoinedRewardPoolQuery } from '@shared/hooks/query/rewardPools';

type Props = {
  rewardPool: RewardPool;
};

export const useIsJoinedToPool = ({ rewardPool }: Props) => {
  const { isAuth, isLoading: isAuthLoading } = useAuth();

  const { data: isSelfJoined = isAuth && Boolean(rewardPool.userJoined), isLoading } =
    useIsSelfJoinedRewardPoolQuery(rewardPool.id, {
      enabled: isAuth && typeof rewardPool.userJoined !== 'boolean',
    });

  return { isJoined: isSelfJoined, isLoading: isLoading || isAuthLoading };
};
